import React, { useState } from "react";
import "./JibuFAQ.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqData = [
  {
    question: "What is JibuBot?",
    answer:
      "JibuBot is a smart AI-powered assistant that automates customer conversations across platforms like WhatsApp, web, and more.",
  },
  {
    question: "Do I need coding skills to use it?",
    answer:
      "Not at all. JibuBot has an intuitive dashboard where you can set up and customize your bot without writing code.",
  },
  {
    question: "Can I integrate it with WhatsApp or Facebook?",
    answer:
      "Yes! JibuBot supports integrations with WhatsApp, Facebook Messenger, websites, and other platforms.",
  },
  {
    question: "Is there a free trial?",
    answer:
      "Yes, we offer a 14-day free trial so you can test JibuBot’s features risk-free.",
  },
  {
    question: "What kind of support do you offer?",
    answer:
      "We offer email and live chat support. Pro and Enterprise plans come with priority and dedicated support.",
  },
];

const JibuFAQ = ({ isDarkMode }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={`jibu-faq ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div className="faq-item" key={index}>
            <button className="faq-question" onClick={() => toggle(index)}>
              <span>{item.question}</span>
              {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {openIndex === index && <p className="faq-answer">{item.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default JibuFAQ;
